import { gql } from '@apollo/client'

export const SHOP_STRIPE_ACCOUNT_FRAGMENT = gql`
  fragment ShopStripeAccount on ShopStripeAccount {
    id
    stripeId
  }
`
